import { drawing } from '@core/models/ClientClinicHist';
import { Service } from '@core/models/Service';

export interface Cabinet {
    professionalId: string;
    professionalName: string;
    laserId: string;
    clientId: string;
    number: string;
    professional: string;
    comments: string;
    services: Partial<CabinetService>[];
    getConsumptionProducts: string;
    consumptionProducts: string;
    drawings: drawing[];
    clinicAnnotation;
}

export interface CabinetService {
    service: Partial<Service>;
    session: string;
    equipment: string;
    pI: string;
    pII: string;
    pIII: string;
    pIV: string;
    shotStart: string;
    shotEnd: string;
    isTreatment: boolean;
}

export const createCabinet = (data: any, services: Service[]): Cabinet => {
    const cabinetServices: CabinetService[] = [];

    data.__list_0.forEach(item => {
        const service = services.find(({ id }) => id === item.zoneid);
        const eqId = item.equipmentid ?? '0';
        const intId = item.interfaceid ?? '0';
        const clinicEqId = item.clinicequipmentid ?? '0';
        cabinetServices.push({
            session: item.sessionnum,
            equipment: `${eqId}_${intId}_${clinicEqId}`,
            pI: item.spotid,
            pII: item.energyid,
            pIII: item.msecid,
            pIV: item.dcdid,
            shotStart: item.shotini ?? '',
            shotEnd: item.shotfin ?? '',
            isTreatment: item.istreatment !== '0',
            service
        });
    });

    return {
        professionalId: data.UserID,
        professionalName: data.UserName,
        laserId: data.LaserGID,
        number: data.CabinetNum,
        clientId: data.ClientID,
        professional: data.UserID === '0' && data.UserName !== '0' ? null : data.UserID,
        comments: data.LLaser,
        services: cabinetServices,
        getConsumptionProducts: '-1',
        consumptionProducts: '',
        drawings: [],
        clinicAnnotation: ''
    };
};
